"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Small = exports.PanelButton = exports.Panel = void 0;

require("core-js/modules/es6.object.freeze");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 9px;\n    color: gray;\n    padding-top: 2px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 3px 20px;\n    border: 1px solid gray;\n    color: darkslategray;\n    background: rgb(241, 241, 241);\n    border-radius: 3px;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    outline: none;\n    font-size: 11px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 300px;\n    background: rgb(241, 241, 241);\n    padding: 15px;\n    margin-bottom: 10px;\n    & > .panel-row:not(:last-of-type) {\n        margin-bottom: 10px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Panel = _styledComponents.default.div(_templateObject());

exports.Panel = Panel;

var PanelButton = _styledComponents.default.button(_templateObject2());

exports.PanelButton = PanelButton;

var Small = _styledComponents.default.div(_templateObject3());

exports.Small = Small;